import axios from "axios";
const URL = process.env.VUE_APP_API;

export default {
  getPredictions() {
    return axios.get(`${URL}/predictions/`).then((res) => {
      return res.data;
    });
  },
  createPrediction(payload) {
    return axios.post(`${URL}/predictions`, { ...payload }).then((res) => {
      return res.data;
    });
  },
  updatePrediction(payload) {
    let config = {
      headers: {
        Accept: "application/json",
      },
    };
    delete payload["image"];
    delete payload["image_result"];
    delete payload["image_mask"];
    return axios
      .patch(`${URL}/predictions/${payload.id}`, payload, config)
      .then((res) => {
        return res.data;
      });
  },

  getPrediction(id) {
    return axios.get(`${URL}/predictions/${id}`).then((res) => {
      return res.data;
    });
  },
  generatePrediction(id) {
    return axios.get(`${URL}/predictions/${id}/generate`).then((res) => {
      return res.data;
    });
  },
  deletePrediction(id) {
    return axios.delete(`${URL}/predictions/${id}`).then((res) => {
      return res.data;
    });
  },
  createAOI(id, payload) {
    return axios
      .post(`${URL}/predictions/${id}/area_of_interests`, { ...payload })
      .then((res) => {
        return res.data;
      });
  },
  updateAOI(predictionId, payload) {
    return axios
      .patch(
        `${URL}/predictions/${predictionId}/area_of_interests/${payload.id}`,
        {
          ...payload,
        },
      )
      .then((res) => {
        return res.data;
      });
  },
  deleteAOI(id, aoi) {
    return axios
      .delete(`${URL}/predictions/${id}/area_of_interests/${aoi}`)
      .then((res) => {
        return res.data;
      });
  },
  getCountries() {
    return axios.get(`${URL}/countries`).then((res) => {
      return res.data;
    });
  },
  getCategories() {
    return axios.get(`${URL}/categories`).then((res) => {
      return res.data;
    });
  },
  getFlows() {
    return axios.get(`${URL}/flows`).then((res) => {
      return res.data;
    });
  },
  getParticipant(testId, participantId) {
    return axios
      .get(
        `${URL}/tests/${testId}/participants/${participantId}?associations=emotions,mice,eyes,sections,significant_points&fields=video`,
      )
      .then((res) => {
        return res.data;
      });
  },
  getPages(id) {
    return axios.get(`${URL}/tests/${id}/labels`).then((res) => {
      return res.data;
    });
  },
  getTags(id) {
    return axios.get(`${URL}/tests/${id}/tags`).then((res) => {
      return res.data;
    });
  },
  createTag(testId, payload) {
    return axios
      .post(`${URL}/tests/${testId}/tags`, { tag: payload })
      .then((res) => {
        return res.data;
      });
  },
  updateTag(tagId, payload) {
    return axios.patch(`${URL}/tags/${tagId}`, { tag: payload }).then((res) => {
      return res.data;
    });
  },
  deleteTag(tagId) {
    return axios.delete(`${URL}/tags/${tagId}`).then((res) => {
      return res.data;
    });
  },
  getTests() {
    return axios.get(`${URL}/tests`).then((res) => {
      return res.data;
    });
  },
  getTest(id) {
    return axios.get(`${URL}/tests/${id}`).then((res) => {
      return res.data;
    });
  },
  getFakeParticipant(id, participantId) {
    return axios.get(`${URL}/tests/${id}/participants/${participantId}/`);
  },
  getVideoParticipant(testId) {
    return axios
      .get(`${URL}/participants/get_video_participant?test_id=${testId}`)
      .then((res) => {
        return res.data;
      });
  },
  createParticipantExport(testId, participantId, data) {
    return axios
      .post(`${URL}/tests/${testId}/participants/${participantId}/export`, {
        data,
      })
      .then((res) => {
        return res.data;
      });
  },
  participantExportUrl(testId, participantId, token) {
    return `${URL}/tests/${testId}/participants/${participantId}/export?token=${encodeURIComponent(
      token,
    )}`;
  },
  createConsultancyNotes(payload) {
    return axios
      .post(`${URL}/consultancy_notes/batch_create`, {
        consultancy_notes: payload,
      })
      .then((res) => {
        return res.data;
      });
  },
  processVideoTest(testId) {
    return axios.get(`${URL}/tests/${testId}/process_video_test`);
  },
  getInsights(id) {
    return axios.get(`${URL}/tests/${id}/insights/`);
  },
  getInsight(id, insightId) {
    return axios.get(`${URL}/tests/${id}/insights/${insightId}`);
  },
  updateInsight(id, insightId, payload) {
    return axios
      .patch(`${URL}/tests/${id}/insights/${insightId}`, { insight: payload })
      .then((res) => {
        return res.data;
      });
  },
  createInsight(id, payload) {
    return axios
      .post(`${URL}/tests/${id}/insights`, { insight: payload })
      .then((res) => {
        return res.data;
      });
  },
  deleteInsight(id, insightId) {
    return axios
      .delete(`${URL}/tests/${id}/insights/${insightId}`)
      .then((res) => {
        return res.data;
      });
  },
  createTest(payload) {
    return axios.post(`${URL}/tests/`, { ...payload }).then((res) => {
      return res.data;
    });
  },
  createTestWithFiles(formData) {
    return axios.post(`${URL}/tests/`, formData).then((res) => {
      return res.data;
    });
  },
  updateTest(payload) {
    return axios
      .patch(`${URL}/tests/${payload.test.id}`, { ...payload })
      .then((res) => {
        return res.data;
      });
  },
  updateTestWithFiles(id, formData) {
    return axios.patch(`${URL}/tests/${id}`, formData).then((res) => {
      return res.data;
    });
  },
  updateTestFile(id, formData) {
    return fetch(`${URL}/tests/${id}`, {
      method: "PATCH",
      headers: {
        Authorization: String(axios.defaults.headers.common["Authorization"]),
        Accept: "application/json",
      },
      body: formData,
    });
  },
  deleteTest(id) {
    return axios.delete(`${URL}/tests/${id}`).then((res) => {
      return res.data;
    });
  },
  deleteParticipant(id, participantId) {
    return axios
      .delete(`${URL}/tests/${id}/participants/${participantId}`)
      .then((res) => {
        return res.data;
      });
  },
  updateFavouriteParticipant(id, participantId) {
    return axios.get(
      `${URL}/tests/${id}/participants/${participantId}/favourite`,
    );
  },
  updateParticipantWithFiles(id, participantId, formData) {
    return axios
      .patch(`${URL}/tests/${id}/participants/${participantId}`, formData)
      .then((res) => {
        return res.data;
      });
  },
  // Sections
  getSections(id, participantId) {
    return axios
      .get(`${URL}/tests/${id}/participants/${participantId}/favourite`)
      .then((res) => {
        return res.data;
      });
  },
  createSection(payload) {
    return axios.post(`${URL}/sections`, { section: payload }).then((res) => {
      return res.data;
    });
  },
  updateSection(id, payload) {
    return axios
      .patch(`${URL}/sections/${id}`, { section: payload })
      .then((res) => {
        return res.data;
      });
  },
  deleteSection(id) {
    return axios.delete(`${URL}/sections/${id}`).then((res) => {
      return res.data;
    });
  },
  // Labels
  getLabels(id) {
    return axios.get(`${URL}/tests/${id}/labels/`);
  },
  createLabel(testId, payload) {
    return axios
      .post(`${URL}/tests/${testId}/labels`, { label: payload })
      .then((res) => {
        return res.data;
      });
  },
  updateLabel(testId, id, payload) {
    return axios
      .patch(`${URL}/tests/${testId}/labels/${id}`, { label: payload })
      .then((res) => {
        return res.data;
      });
  },
  deleteLabel(testId, id) {
    return axios.delete(`${URL}/tests/${testId}/labels/${id}`).then((res) => {
      return res.data;
    });
  },
  getHeatmaps(id) {
    return axios.get(`${URL}/tests/${id}/heatmaps`).then((res) => {
      return res.data;
    });
  },
  getHeatmap(id, heatmapId) {
    return axios.get(`${URL}/tests/${id}/heatmaps/${heatmapId}`).then((res) => {
      return res.data;
    });
  },
  deleteHeatmap(id, heatmapId) {
    return axios
      .delete(`${URL}/tests/${id}/heatmaps/${heatmapId}`)
      .then((res) => {
        return res.data;
      });
  },
  createHeatmap(testId, payload) {
    return axios
      .post(`${URL}/tests/${testId}/heatmaps`, { heatmap: payload })
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        return error.response.data;
      });
  },
  updateHeatmap(testId, payload) {
    return axios
      .patch(`${URL}/tests/${testId}/heatmaps/${payload.id}`, {
        heatmap: payload,
      })
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        return error.response.data;
      });
  },
  getSuggestions(testId) {
    return axios.get(`${URL}/tests/${testId}/suggestions`).then((res) => {
      return res.data;
    });
  },
  getSuggestion(testId, suggestionId) {
    return axios
      .get(`${URL}/tests/${testId}/suggestions/${suggestionId}`)
      .then((res) => {
        return res.data;
      });
  },
  createSuggestion(payload) {
    return axios
      .post(`${URL}/tests/${payload.test_id}/suggestions`, {
        suggestion: payload,
      })
      .then((res) => {
        return res.data;
      });
  },
  updateSuggestion(payload) {
    return axios
      .patch(`${URL}/tests/${payload.test_id}/suggestions/${payload.id}.json`, {
        suggestion: payload,
      })
      .then((res) => {
        return res.data;
      });
  },
  deleteSuggestion(testId, suggestionId) {
    return axios
      .delete(`${URL}/tests/${testId}/suggestions/${suggestionId}`)
      .then((res) => {
        return res.data;
      });
  },
};
